import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useRef, useCallback, useEffect } from "react";
import Image from "next/image";
import classnames from "classnames";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import SliderCore from "@/components/SliderCore";
import isOuterAreaClick from "@/lib/isOuterAreaClick";
import styles from "@/styles/LightBox.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconClose = function IconClose(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: "48",
      height: "48",
      fill: "rgba(255,255,255,0)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12,11.293,22.293,1,23,1.707,12.707,12,23,22.293,22.293,23,12,12.707,1.707,23,1,22.293,11.293,12,1,1.707,1.707,1Z",
      transform: "translate(12 12)",
      fill: "#909090",
      fillRule: "evenodd"
    })]
  }));
};

IconClose.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
};
var sliderOptions = {
  slidesPerView: 1,
  slidesPerGroup: 1,
  navigation: true,
  effect: "fade"
};
export default function LightBox(_ref) {
  var show = _ref.show,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      onClose = _ref.onClose;
  if (!images || images.length === 0) return null;

  if (images.length === 1) {
    sliderOptions.navigation = false;
  } else {
    sliderOptions.navigation = true;
  }

  var screen = useRef();
  var content = useRef();
  var onScreenClick = useCallback(function (e) {
    if (isOuterAreaClick(content.current, e)) {
      if (typeof onClose === "function") onClose(e);
      enableBodyScroll(screen.current);
    }
  }, [content.current, onClose]);
  useEffect(function () {
    if (show) {
      disableBodyScroll(screen.current);
    }

    return function () {
      clearAllBodyScrollLocks();
    };
  }, [show]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.container, _defineProperty({}, styles.show, show)),
    ref: screen,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      onClick: onScreenClick,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.navigation,
        children: /*#__PURE__*/_jsx("button", {
          className: styles.close,
          tabIndex: "0",
          role: "button",
          children: /*#__PURE__*/_jsx(IconClose, {})
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.sliderWrapper,
        children: images && /*#__PURE__*/_jsx(SliderCore, {
          sliderOptions: sliderOptions,
          children: images.map(function (image, i) {
            return /*#__PURE__*/_jsx("div", {
              className: styles.item,
              children: /*#__PURE__*/_jsx("div", {
                className: styles.image,
                ref: content,
                children: /*#__PURE__*/_jsx(Image, {
                  src: image,
                  width: 320,
                  height: 180,
                  layout: "responsive",
                  objectFit: "contain"
                })
              })
            }, "lightbox-item-".concat(i));
          })
        })
      })]
    })
  });
}